import {Component, ElementRef, OnInit, QueryList, ViewChildren} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MessageService} from "primeng/api";
import {Router} from "@angular/router";
import {OptionResponseDto} from "../../../dto/option.reponse.dto";
import {CatalogService} from "../../../services/catalog.service";
import {FileUpload} from "primeng/fileupload";
import {InputNumber} from "primeng/inputnumber";

interface FileWithPreview extends File {
    objectURL?: string;
}

@Component({
    selector: 'app-register-document',
    templateUrl: './register-document.component.html',
    styleUrls: ['./register-document.component.scss'],
    providers: [MessageService]
})
export class RegisterDocumentComponent implements OnInit {
    @ViewChildren('codeInput') codeInputRefs!: QueryList<ElementRef>;

    activeTabIndex: number = 0;
    identityForm!: FormGroup;
    isNotDataValid: boolean = false;
    titleIdentity: string = 'Verifica tu identidad';
    titleEmail: string = 'Verifica tu correo';
    titleCell: string = 'Verifica tu celular';
    activeIdentityTab: boolean = false;
    activeEmailTab: boolean = false;
    activeCellTab: boolean = false
    files: FileWithPreview[] = [];
    filesSelect: FileWithPreview[] = [];
    filesUploaded: boolean = false;
    isUploaded: boolean = false;
    registerSuccess: boolean = false;
    // Control de verificación
    isEmailVerified = false;
    isCellVerified = false;
    identityTypes: OptionResponseDto[] = [];
    selectedIdentityTypes: string = 'CI_ID';

    verificationStep: 'identity' | 'email' | 'cell' = 'identity';
    codeValues: string[] = Array(6).fill('');  // Array to store the verification code values
    verificationCode: string = '';
    val1!: number;

    val2!: number;

    val3!: number;

    val4!: number;
    val5!: number;
    val6!: number;
    valEmail1!: number;
    valEmail2!: number;
    valEmail3!: number;
    valEmail4!: number;
    valEmail5!: number;
    valEmail6!: number;


    constructor(private formBuilder: FormBuilder,
                private messageService: MessageService,
                private router: Router,
                private catalogService: CatalogService) {
    }

    ngOnInit(): void {
        this.identityForm = this.formBuilder.group({
            termsAccepted: ['', Validators.requiredTrue],
        });
        this.loadCatalogOptions('CT_IDENTITY_TYPE', 'identityTypes');
    }
    private loadCatalogOptions(catalog: string, targetField: 'identityTypes'): void {
        this.catalogService.getCatalogList(catalog).subscribe(
            (options) => {
                console.log('Opciones cargadas: ', options);  // Agrega esta línea
                if (Array.isArray(options)) {  // Verifica que options sea un array
                    this[targetField] = options;
                    if (targetField === 'identityTypes' && options.length > 0) {
                        this.setDefaultOption('ctIdentityType', options);
                    }
                } else {
                    console.error('Error: Se esperaba un array, pero se recibió: ', options);
                }
            },
            (error) => {
                console.error('Error catalogs',error);
            }
        );
    }


    // Establecer valor predeterminado en dropdown si hay opciones disponibles
    private setDefaultOption(controlName: string, options: OptionResponseDto[]): void {
        this.identityForm.patchValue({ [controlName]: options[0].optionCode });
    }


    // Triggered when files are selected (preview only)
    onSelect(event: any) {
        for (let file of event.files) {
            const fileWithPreview = {
                ...file,
                objectURL: this.createObjectURL(file) // Generate preview URL for each file
            };
            this.filesSelect.push(fileWithPreview);  // Add the file to the array for preview
        }
        this.filesUploaded = this.filesSelect.length > 0;  // Update the files uploaded flag (to handle empty state)
    }

    // Handle file uploads (do not push files again, just handle the upload success)
    onUpload(event: FileUpload) {
        console.log(event);
        for (let file of event.files) {
            const fileWithPreview = {
                ...file,
                objectURL: this.createObjectURL(file) // Generate preview URL for each file
            };
            this.files.push(fileWithPreview);  // Add the file to the array for preview
        }
        this.isUploaded = true;  // Mark files as successfully uploaded
        this.messageService.add({severity: 'info', summary: 'File Uploaded', detail: ''});
        this.titleIdentity = 'Identidad verificada';
        this.activeIdentityTab = true;

        this.moveToNextStep();
    }
    // Create an object URL for image preview
    createObjectURL(file: any) {
        return window.URL.createObjectURL(file);
    }

// Manejo del autocompletado y actualización de valores en los inputs
    handleInput(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;
        const value = input.value;

        // Solo acepta valores de un solo carácter y lo guarda en codeValues
        if (value.length === 1) {
            this.codeValues[index] = value;
            console.log('codeValues:', this.codeValues);
            // Mueve el foco al siguiente input si existe
            if (index < this.codeInputRefs.length - 1) {
                const nextInput = this.codeInputRefs.toArray()[index + 1];
                nextInput.nativeElement.value = ''; // Limpia el valor del siguiente input antes de enfocarlo
                nextInput.nativeElement.focus();
                console.log('denro del if:', index, 'value:', value, 'nextInput:', nextInput,
                    'codeInputRefs', this.codeInputRefs);
            }
            console.log('index:', index, 'value:', value,
                'codeInputRefs', this.codeInputRefs);
        } else if (value === '') {
            console.log('codeValues =" ":', this.codeValues);
            // Si se borra el valor, limpiar el valor en codeValues
            this.codeValues[index] = '';
            // Mover el foco al input anterior si existe
            if (index > 0) {
                this.codeInputRefs.toArray()[index - 1].nativeElement.focus();
            }
        }

        // Actualizar el código de verificación completo
        this.updateVerificationCode();

        // Si se completan los 6 dígitos, validar el código
        if (this.verificationCode.length === 6) {
            this.validateCode();
        }
    }

    focusOnNext(inputEl: InputNumber) {
        inputEl.input.nativeElement.focus();
        // Si se completan los 6 dígitos, validar el código
        if (this.verificationCode.length === 6) {
            this.validateCode();
        }
    }

    // Limpiar el array codeValues para reiniciar los inputs
    clearCodeValues(): void {
        this.codeValues = Array(6).fill(''); // Reinicia los valores
    }

    // Actualizar el código de verificación concatenando todos los valores de codeValues
    updateVerificationCode(): void {
        this.verificationCode = this.codeValues.join('');
    }


    // Cambiar la verificación entre email y celular y limpiar los inputs
    switchVerification(step: 'email' | 'cell'): void {
        this.verificationStep = step;
        this.clearCodeValues(); // Limpiamos el array al cambiar de pestaña
    }
    // Validar el código dependiendo de la etapa (email o celular)
    validateCode(): void {
        const endpoint = this.verificationStep === 'email' ? '/api/validate-email-code' : '/api/validate-cell-code';
        const payload = { code: this.verificationCode };
        if(payload.code === '123456'){
            this.messageService.add({ severity: 'success', summary: 'Código validado correctamente' });
            if (this.verificationStep === 'email') {
                this.moveToNextStep();
                this.isEmailVerified = true; // Deshabilita los inputs de email después de la verificación
                this.switchVerification('cell');
                this.titleEmail = 'Correo verificado';
            } else if (this.verificationStep === 'cell') {
                this.isCellVerified = true; // Deshabilita los inputs de celular después de la verificación
                this.titleCell = 'Celular verificado';
            }

        }else {
            this.messageService.add({ severity: 'error', summary: 'Código incorrecto' });
            this.clearCodeValues(); // Limpia los inputs si el código es incorrecto
            this.codeInputRefs.first.nativeElement.focus(); // Enfoca el primer input
        }

        // // Llamada al backend para validar el código
        // this.http.post(endpoint, payload).subscribe(
        //     (response: any) => {
        //         if (response.success) {
        //             this.messageService.add({ severity: 'success', summary: 'Código correcto', detail: '' });
        //             this.moveToNextStep();
        //         } else {
        //             this.messageService.add({ severity: 'error', summary: 'Código incorrecto' });
        //         }
        //     },
        //     (error) => {
        //         this.messageService.add({ severity: 'error', summary: 'Error en la validación' });
        //     }
        // );
    }


    // Move to the next verification step
    moveToNextStep(): void {
        if (this.verificationStep === 'identity') {
            this.verificationStep = 'email';
            this.activeTabIndex = 1;
            this.activeEmailTab = true;
        } else if (this.verificationStep === 'email') {
            this.verificationStep = 'cell';
            this.activeTabIndex = 2;
            this.activeCellTab = true;
        } else if (this.verificationStep === 'cell') {
        }
    }

    // Validation messages helper
    getValidationMessages(controlName: string): string[] {
        const control = this.identityForm.controls[controlName];
        const messages: string[] = [];

        if (control.errors) {
            for (const errorName of Object.keys(control.errors)) {
                switch (errorName) {
                    case 'required':
                        messages.push(`${controlName} es requerido.`);
                        break;
                    case 'minlength':
                        messages.push(`${controlName} debe tener al menos ${control.errors['minlength'].requiredLength} caracteres.`);
                        break;
                    case 'email':
                        messages.push(`${controlName} debe ser un correo electrónico válido.`);
                        break;
                }
            }
        }

        return messages;
    }

    // Form submission handler
    onSubmit(): void {
        if (this.identityForm.invalid) {
            this.isNotDataValid = true;
            return;
        }
        this.registerSuccess = true;
    }

    // Método para navegar a otro componente
    navigateToOtherComponent(): void {
        this.router.navigate(['/properties']);  // Ajusta 'nombre-del-componente' según la ruta de destino
    }
}
